import { Modal } from "antd";
import { FC } from "react";

import BaseButton from "@/components/BaseButton";
import { PrimaryText, SecondaryText } from "@/components/Typography/Styled";

import { IgnoreRemainingConfirmProps } from "./ignoreRemainingConfirm.interface";
import { StyledConfirmRemainingButton, StyledDangerIcon } from "./Styled";

export const IgnoreRemainingConfirm: FC<IgnoreRemainingConfirmProps> = ({
    modalKey,
    isModalOpened,
    confirmRemaining,
    cancelRemaining,
}) => {
    return (
        <Modal
            key={modalKey}
            open={isModalOpened}
            onOk={() => confirmRemaining()}
            onCancel={() => cancelRemaining()}
            centered
            footer={[]}
        >
            <StyledDangerIcon />
            <PrimaryText
                fontSize={20}
                fontWeight="500"
                style={{ textAlign: "center" }}
            >
                Ви впевнені?
            </PrimaryText>
            <SecondaryText
                fontSize={16}
                fontWeight="400"
                style={{ lineHeight: "130%", marginTop: "16px" }}
            >
                Відсутні на складі товари не будуть доставлені в магазин.
                Підтверджуючи ігнорування залишків, ви приймаєте ризик
                невідповідності замовлення фактичній поставці. Ви впевнені?
            </SecondaryText>
            <StyledConfirmRemainingButton
                type="primary"
                onClick={() => confirmRemaining()}
            >
                Підтвердити
            </StyledConfirmRemainingButton>
            <BaseButton
                type="default"
                onClick={() => cancelRemaining()}
                marginTop="16px"
            >
                Повернутися назад
            </BaseButton>
        </Modal>
    );
};
